import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=6394da57&scoped=true&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=6394da57&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6394da57",
  null
  
)

export default component.exports